import React from 'react';
import { Flex, Icon, Text } from 'pounceV2';
import { RuleStepData } from 'Pages/Build/Detections/CorrelationRules/utils';
import { useTheme } from '@mui/material';
import AbsentTagV3 from './AbsentTagV3';
import MatchCountTagV3 from './MatchCountTagV3';
import { getFlowChartColors } from '../../constantsV3';

const CountInfoV3 = ({ stepData }: { stepData: RuleStepData }) => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  if (!stepData?.Absence && !stepData.MinMatchCount && !stepData.MaxMatchCount) {
    return null;
  }
  if (stepData?.Absence && (stepData.MinMatchCount || stepData.MaxMatchCount)) {
    return (
      <Flex direction="row" align="flex-start" gap={1}>
        <Icon color={FLOW_CHART_COLORS.ERROR.BORDER} size="small" type="warning" p={0} />
        <Text variant="body/sm" color={FLOW_CHART_COLORS.ERROR.BORDER}>
          The rule cannot be absent with min or max match count
        </Text>
      </Flex>
    );
  }
  return (
    <>
      {stepData?.MinMatchCount || stepData?.MaxMatchCount ? (
        <Flex direction="row" gap={2}>
          {stepData?.MinMatchCount ? (
            <MatchCountTagV3 count={stepData?.MinMatchCount} isMin={true} />
          ) : null}
          {stepData?.MinMatchCount && stepData?.MaxMatchCount ? (
            <Text variant="body/sm" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
              {'|'}
            </Text>
          ) : null}
          {stepData?.MaxMatchCount ? (
            <MatchCountTagV3 count={stepData?.MaxMatchCount} isMin={false} />
          ) : null}
        </Flex>
      ) : null}
      {stepData?.Absence ? <AbsentTagV3 /> : null}
    </>
  );
};

export default CountInfoV3;
